/**
 * Turn a `/api/integrations/capabilities` response body into a yes/no.
 *
 * Lives in its own module, importing nothing, so the rule can be tested
 * without dragging in the axios client (and therefore without a network stub
 * or an ESM transform).
 *
 * Strict `=== true` on purpose: a truthy `1`, `"true"` or even `"false"` would
 * be a backend contract change, not permission, and must read as denied. Same
 * rule the server applies to the column itself.
 */
export function parseCapabilityResponse(payload: unknown): boolean {
  return (payload as any)?.capabilities?.can_install_external_integrations === true;
}

export default parseCapabilityResponse;
